import { useEffect } from 'react';

export default function Seo({ title, description, canonical, jsonLd, noindex = false }) {
  const jsonLdKey = jsonLd ? JSON.stringify(jsonLd) : '';

  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, isProperty = false) => {
      if (!content) return;
      const attr = isProperty ? 'property' : 'name';
      let tag = document.querySelector(`meta[${attr}="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    if (description) {
      setMeta('description', description);
      setMeta('og:description', description, true);
    }
    if (title) setMeta('og:title', title, true);

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    if (noindex) setMeta('robots', 'noindex, nofollow');
    else setMeta('robots', 'index, follow');

    // Google Search Console verification — env-driven, optional.
    const gsv = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION;
    if (gsv) setMeta('google-site-verification', gsv);

    // JSON-LD
    const existing = document.querySelectorAll('script[data-seo-jsonld="true"]');
    existing.forEach((s) => s.remove());
    if (jsonLdKey) {
      const parsed = JSON.parse(jsonLdKey);
      const items = Array.isArray(parsed) ? parsed : [parsed];
      items.forEach((item) => {
        const s = document.createElement('script');
        s.type = 'application/ld+json';
        s.dataset.seoJsonld = 'true';
        s.textContent = JSON.stringify(item);
        document.head.appendChild(s);
      });
    }

    // lang
    document.documentElement.lang = 'nb';
  }, [title, description, canonical, jsonLdKey, noindex]);

  return null;
}
